module.exports = __webpack_public_path__ + "static/img/news.35cf7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news.png
// module id = d/6q
// module chunks = 1